import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'et-atoms-web-back-btn',
  templateUrl: './web-back-btn.component.html',
  styleUrls: ['./web-back-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WebBackBtnComponent {}
